import React from 'react';
import { ScrollView, View } from 'react-native';
import { Device } from 'DeviceUtils';
// eslint-disable-next-line import/no-cycle
import AssetDetail from 'LocalGluons/components/AssetDetail';
import InfoList from 'LocalGluons/components/InfoList';
import { getInfoListItems } from 'Utils/index';
import type { StyleMap, PlayerData } from 'Types';
import Icon from '../../../Icon';

import defaultStyles from './DetailModal.jss';

const playerInfoStatus = !!Device.isPhone;

interface DetailModelProps {
    style: StyleMap;
    currentItem: PlayerData['item'];
    onClose: () => void;
    onNavigate: () => void;
}

const DetailModal = ({
    style,
    currentItem,
    onClose,
    onNavigate
}: DetailModelProps): React.ReactElement =>
(
    <View style={[defaultStyles.container, style]}>
        <ScrollView contentContainerStyle={defaultStyles.scrollContainer}>
            <Icon name="close" style={defaultStyles.iconClose} onPress={onClose} />
            <AssetDetail
                isPlayerInfo={playerInfoStatus}
                style={defaultStyles.assetDetail}
                item={currentItem}
                subtitleStyle={defaultStyles.subTitle}
            />
            <InfoList
                isPlayerInfo={playerInfoStatus}
                onNavigate={onNavigate}
                items={getInfoListItems(currentItem)}
                isSingleColumn={Device.isTabletOrWeb}
            />
        </ScrollView>
    </View>
)
    ;

export default DetailModal;
